module.exports = __webpack_public_path__ + "media/3.becf34f4.mp3";